import { createAsyncThunk } from '@reduxjs/toolkit';

import { set } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';
import getMyProfile from '../profile/getMyProfile';

const postLogin = createAsyncThunk('auth/login',
  async (formData = {}, { rejectWithValue, dispatch }) => {
    try {
      const response = await set(METHOD_POST, '/login', formData);

      if (response?.token) {
        localStorage.setItem('token', JSON.stringify({ token: response.token }));
        dispatch(getMyProfile());
      }

      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postLogin;
